import { css } from '@emotion/react'
import { Tag, Theme, useTheme } from 'bold-ui'
import { OrigemDadoEnum } from 'graphql/types.generated'

interface TagOrigemAcompanhamentoCidadaosVinculadosProps {
  origem: OrigemDadoEnum
}

export const TagOrigemAcompanhamentoCidadaosVinculados = (props: TagOrigemAcompanhamentoCidadaosVinculadosProps) => {
  const { origem } = props
  const theme = useTheme()
  const styles = createStyles(theme)

  return <Tag style={origem === OrigemDadoEnum.CDS ? styles.cds : styles.pec}>{origem}</Tag>
}

const createStyles = (theme: Theme) => ({
  pec: css`
    background-color: ${theme.pallete.primary.c80};
    color: ${theme.pallete.gray.c10};
  `,
  cds: css`
    background-color: ${theme.pallete.primary.c30};
    color: ${theme.pallete.gray.c100};
  `,
})
